<template lang="pug">
div
  a.btn.btn-link(@click="$router.back()")
    i.fa.fa-arrow-left
    |
    | Voltar
  .divider
  load-manager(:status="status")
    div(v-if="current")
      show-mensagem(:mensagem="current")
      recursive-messages(:mensagem="current")
      .divider
      div
        a.btn.btn-link.text-error(
          v-if="!current.arquivada_remetente",
          @click="arquivar"
        )
          i.fa.fa-archive
          |
          | Arquivar
        a.btn.btn-link(v-else, @click="restaurar")
          i.fa.fa-refresh
          |
          | Restaurar
</template>

<script>
import ShowMensagem from '../components/ShowMensagem.vue'
import RecursiveMessages from '../components/RecursiveMessages.vue'
import parseErrors from '@/lib/errors/parseErrors'

export default {
  vuex: {
    'mensagens/enviadas': {
      state: ['current', 'status'],
      actions: ['fetchOne', 'fetchArquivar', 'fetchRestaurar'],
      getters: ['loading'],
    },
  },
  components: { ShowMensagem, RecursiveMessages },
  methods: {
    async getMensagem() {
      await this.fetchOne(this.$route.params.id)
    },

    async arquivar() {
      const { ok } = await this.$dialogs.confirm(
        'Deseja arquivar a mensagem?',
        {
          title: 'Arquivar mensagem',
          cancelLabel: 'Não',
          okLabel: 'Sim',
          size: 'sm',
        },
      )

      if (ok) {
        try {
          await this.fetchArquivar(this.current.id)
          this.$toaster.success('Mensagem arquivada')
          this.$router.back()
        } catch (e) {
          this.$toaster.error(parseErrors(e).join(', '))
        }
      }
    },

    async restaurar() {
      const { ok } = await this.$dialogs.confirm(
        'Deseja restaurar a mensagem?',
        {
          title: 'Restaurar mensagem',
          cancelLabel: 'Não',
          okLabel: 'Sim',
          size: 'sm',
        },
      )

      if (ok) {
        try {
          await this.fetchRestaurar(this.current.id)
          this.$toaster.success('Mensagem restaurada')
          this.$router.back()
        } catch (e) {
          this.$toaster.error(parseErrors(e).join(', '))
        }
      }
    },
  },
  created() {
    this.getMensagem()
  },
}
</script>
